import styles from './css/CreateNewPassword.css';

import React from 'react';
import { Link } from 'react-router';
import { TextInput, Button, Icon } from '@tcc/crate';
import { getMessage } from '../../i18n/i18nWrapper';
import PropTypes from 'prop-types';

export const CreateNewPassword = ({
  createPassword,
  errorText,
  isCreateFetching,
  password,
  passwordConfirm,
  setPassword,
  setPasswordConfirm,
  checkPasswordLength
}) => {

  function formCreatePassword(e) {
    e.preventDefault();
    createPassword();
  }

  const confirmMsg = getMessage('createPasswordMessages.confirmInput');
  const errorMsg = getMessage(`createPasswordMessages.error.${errorText}`);

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer} data-test-id="climate-fv-logo">
        <Icon className={styles.logo} glyph={Icon.set.CLIMATE_PORTAL_COLOR} />
      </div>
      <p className={styles.title}>
        {getMessage('createPasswordMessages.title')}
      </p>

      <form className={styles.createNewPasswordForm} onSubmit={formCreatePassword}>
        <TextInput
          error={errorMsg}
          label={getMessage('createPasswordMessages.passwordInput')}
          name="password"
          onBlur={checkPasswordLength}
          onChange={setPassword}
          type="password"
          value={password} />
        <div className={styles.inputContainer}>
          <TextInput
            className={styles.input}
            error={errorText === 'notMatchingPasswords' ? confirmMsg : ''}
            label={confirmMsg}
            name="passwordConfirm"
            onChange={setPasswordConfirm}
            type="password"
            value={passwordConfirm} />
        </div>
        <Button
          className={styles.button}
          isLoading={isCreateFetching}
          mode="primary"
          type="submit">
          {getMessage('createPasswordMessages.button')}
        </Button>
      </form>

      <Link
        className={styles.link}
        data-test-id="back-to-login"
        href={`${window.location.pathname}#/`}
      >
        {getMessage('createPasswordMessages.knowPassword')}
      </Link>
    </div>
  );
};

CreateNewPassword.propTypes = {
  checkPasswordLength: PropTypes.func.isRequired,
  createPassword: PropTypes.func.isRequired,
  errorText: PropTypes.string.isRequired,
  isCreateFetching: PropTypes.bool.isRequired,
  password: PropTypes.string.isRequired,
  passwordConfirm: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
  setPasswordConfirm: PropTypes.func.isRequired
};

export default CreateNewPassword;
